import { render, staticRenderFns } from "./MasterStatusBadge.vue?vue&type=template&id=15be6a8c&scoped=true"
import script from "./MasterStatusBadge.vue?vue&type=script&lang=js"
export * from "./MasterStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./MasterStatusBadge.vue?vue&type=style&index=0&id=15be6a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be6a8c",
  null
  
)

export default component.exports